export default __webpack_public_path__ + "static/media/qrcode-site-480w.c773738d.webp";